"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollLock = void 0;
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
function useScrollLock(active = true, mountAction) {
    const [element, setElement] = (0, react_1.useState)();
    const ref = (0, react_1.useCallback)((node) => node && setElement(node), []);
    (0, react_1.useEffect)(() => {
        mountAction === null || mountAction === void 0 ? void 0 : mountAction();
        if (element) {
            if (active) {
                utils_1.globalScrollLock.disableBodyScroll(element, {
                    reserveScrollBarGap: true,
                    allowTouchMove: (el) => {
                        let elCopy = el;
                        while (elCopy && elCopy !== document.body) {
                            if (elCopy.tagName === 'DIALOG') {
                                return true;
                            }
                            if (elCopy.parentElement) {
                                elCopy = elCopy.parentElement;
                            }
                        }
                        return false;
                    },
                });
            }
            else {
                utils_1.globalScrollLock.enableBodyScroll(element);
            }
        }
        return () => utils_1.globalScrollLock.clearAllBodyScrollLocks();
    }, [active, mountAction, element]);
    return ref;
}
exports.useScrollLock = useScrollLock;
